import MasterDashboard from './components/MasterDashboard';

function App() {
  return <MasterDashboard />;
}

export default App;
